import { useMutation } from "react-query";
import departmentService from "@services/department-service";

export const useDownloadDepartmentsTemplateUploadMutation = () => {
  return useMutation(departmentService.downloadTemplateUpload);
};
